import React, { createContext, useEffect, useState } from 'react'
import { Button, Card, Col, Icon, Row, Typography } from 'antd'
import ActionsPlanFilter from './ActionsPlan.filter'
import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { getMessage } from '../../util/IntlMessages'
import { api, request } from '../../util/handlerRequestUtil'
import ActionPlainList from './ActionsPlan.list'

const { Title, Text } = Typography

export const ActionsPlanContext = createContext({})

const ActionsPlan = ({ match, history }) => {
  const searchParams = new URLSearchParams(window.location.search)
  const { district, region, safra } = Object.fromEntries(searchParams.entries())
  const INITIAL_STATE = {
    idSafra: safra || '',
    idRegion: region || '',
    idDistrict: district || '',
    customerName: ''
  }
  const [categoriaAcao, setCategoriaAcao] = useState({})
  const [filters, setFilters] = useState({ ...INITIAL_STATE })
  const contextValue = { filters, setFilters }

  useEffect(() => {
    load()
  }, [])

  const load = async () => {
    const response = await request(api.getCategoryAction(match.params.id))
    setCategoriaAcao(response)
  }

  return (
    <ActionsPlanContext.Provider value={contextValue}>
      <div className="default-header-div">
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
          <div className="header-buttons">
            <Button className="button-return" style={{ alignSelf: 'flex-end' }} onClick={() => history.goBack()}>
              <Icon type="left" theme="outlined" style={{ fontSize: '14px' }} />
              {getMessage('back')}
            </Button>
          </div>
        </div>
      </div>
      <Card className="ant-card gx-card ant-card-bordered">
        <Row type="flex" justify="space-between">
          <Col>
            <Title className="default-header-title" level={4}>
              {categoriaAcao.name} <Text disabled>({categoriaAcao.categoria && categoriaAcao.categoria.name})</Text>
            </Title>
          </Col>
          <Col>
            <Title level={4}>
              <Text disabled>
                {getMessage('categoryActionClassificationBayer')}: <Icon type="star" style={{ fontSize: 20 }} />{' '}
                {categoriaAcao.classificacao}
              </Text>
            </Title>
          </Col>
        </Row>
        <ActionsPlanFilter idCategoriaAcao={match.params.id} />
        <ActionPlainList categoriaAcao={categoriaAcao} />
      </Card>
    </ActionsPlanContext.Provider>
  )
}

export default ActionsPlan
